import { render, staticRenderFns } from "./MyCourses.vue?vue&type=template&id=45a45ca2&scoped=true&"
import script from "./MyCourses.vue?vue&type=script&lang=js&"
export * from "./MyCourses.vue?vue&type=script&lang=js&"
import style0 from "./MyCourses.vue?vue&type=style&index=0&id=45a45ca2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a45ca2",
  null
  
)

export default component.exports